import { useCallback, useMemo, useState } from "react";
import { LinkExtension, ShortcutHandlerProps } from "@remirror/extension-link";
import { useExtensionEvent } from "@remirror/react";
import { useAtom } from "jotai";
import { isEditingLinkAtomFamily } from "../state/isEditingLinkAtomFamily";

export function useLinkShortcut(nodeId: string) {
  const [linkShortcut, setLinkShortcut] = useState<
    ShortcutHandlerProps | undefined
  >();
  const [isEditing, setIsEditing] = useAtom(isEditingLinkAtomFamily(nodeId));

  useExtensionEvent(
    LinkExtension,
    "onShortcut",
    useCallback(
      (props) => {
        if (!isEditing) {
          setIsEditing(true);
        }

        return setLinkShortcut(props);
      },
      [isEditing, setIsEditing],
    ),
  );

  return useMemo(
    () => ({ linkShortcut, isEditing, setIsEditing }),
    [linkShortcut, isEditing, setIsEditing],
  );
}
